/** Platform card checkout, cart, Stripe Connect, and Exchange Pass UI. */
export const PAYMENTS_ENABLED = true
